import React from 'react';
import { Redirect } from "react-router-dom";
import { 
    apiConfirmCME, apiDeRegister, apiGetUserDetails, 
    apiLoginUser, apiUpdateUser, apiGetLeaderboard, 
    apiGetAccessList, apiUpdateNotification, apiGetDailyQuestion,
    apiRateApp, apiSendSASPResidentAccess,
    apiGetSASPResidencyProgram,
    apiGetSASPResidenctData,
    apiGetSASPYears,
    apiGetAppReporting,
    apiGetMessages
} from "../api";
import { hashString, clearStorage, getLocalStorage } from "../common";
import { 
    SASP_LEADREBOARD, SASP_LEADREBOARD_FAILED, 
    CME_CONFIRMATION, CME_CONFIRMATION_FAILED, 
    DEREGISTER, DEREGISTER_FAILED, 
    GET_USER_DETAILS, GET_USER_DETAILS_FAILED, 
    LOGIN_USER_FAIL, LOGIN_USER_SUCCESS, 
    SEND_SUCCESS_LOGIN_FEEDBACK, 
    LOGOUT_SUCCESS, LOGOUT_FAILURE, 
    UPDATE_PROFILE, UPDATE_PROFILE_FAIL, 
    SHARE_USERS, SHARE_USERS_FAILED, 
    NOTIFICATIONS, NOTIFICATIONS_FAILED,
    PERSISTANT_LOGIN, PERSISTANT_LOGIN_FAIL, 
    DAILY_USER, DAILY_USER_FAIL, RATE_APP, RATE_APP_FAILED, GET_RESIDENCY_PROGRAM, 
    GET_RESIDENCY_PROGRAM_FAILED, GET_RESIDENT_DATA, GET_RESIDENT_DATA_FAILED,
    SASP_CME_YEARS,
    SASP_REPORT,
    GET_MESSAGES
} from "./types";

export const getDailyQuestion = (data) => async dispatch => {
    const response = await apiGetDailyQuestion(data);
    try {
        dispatch({
            type: DAILY_USER,
            payload: response
        })
    } catch (e) {
        dispatch({
            type: DAILY_USER_FAIL,
            payload: e
        })
    }
}

export const persistantLogin = () => dispatch => {
    const _af = JSON.parse(getLocalStorage('auth_feedback'));

    try {
        dispatch(login_success(_af));
    } catch (error) {
        dispatch(login_fail(error));
    }
}

export const login = ({ id_email, password }) => async dispatch => {
    let id = id_email.includes("@") ? "" : id_email;
    let email = id_email.includes("@") ? id_email : "";

    let deviceName = window.navigator.platform;
    let concatString = deviceName + id;
    let deviceid = hashString(concatString);

    if (window.cordova) {
        if (window.device) {
            switch(window.device.platform.toLowerCase()) {
                case 'browser': {
                    deviceName = window.device.model + '(' + window.device.version + ')';
                    break;
                }
                case 'android': {
                    deviceName = window.device.platform + ' (' + window.device.manufacturer + ' ' + window.device.version + ')';
                    deviceid = window.device.uuid;
                    break;
                }
                default: {
                    deviceName = window.device.platform + ' (' + window.device.model + ' ' + window.device.version + ')';
                    deviceid = window.device.uuid;
                    break;
                }
            }
        }
    }

    let profileData = {
        mcid: id,
        email: email,
        password: password,
        deviceName: deviceName,
        deviceid: deviceid,
        appID: "org.auanet.auau.sasp"
    };

    try {
        const response = await apiLoginUser(profileData);

        if (typeof response === 'string') {
            let _error = {
                errorCode:Math.floor(Math.random() * 11) + 19,
                errorMessage: 'There was an error with the AUA app servers. <br><br>Please try again later.',
                errorKey: Math.floor((Math.random() * 1600000) + 16000000).toString(16)
            };
            dispatch(login_fail(_error));
            return null;
        }

        let _json = JSON.stringify(response);

        if (response.authorized === '1' || response.authorized === 1) {
            let _date = new Date();
            let _d = Number(Date.parse(_date));
            let _offset = 1000 * 60 * 60 * 24 * 30;
            _d += _offset

            localStorage.setItem('login_dt', _d);
            localStorage.setItem('auth_feedback', _json);
        } else {
        }
        
        dispatch(login_success(response));
    } catch (e) {
        let error = {
            errorCode: Math.floor(Math.random() * 11) + 9,
            errorMessage: "There was an error with the AUA app servers. <br><br>Please try again later.",
            errorKey: Math.floor((Math.random() * 1600000) + 16000000).toString(16)
        }
        dispatch(login_fail(error));
    }
};

export const testApi = async () => {
    const response = await apiLoginUser({
        mcid: "01006473",
        email: "",
        password: "Aua2017"
    });
};

const login_success = code => async dispatch => {
    let error = {
        errorMessage: "",
        errorCode: ""
    };

    if (typeof code === 'undefined') {
        return (<Redirect to="/errror" message='Error: Authentication Error'/>)
    }

    clearStorage('sasp-hideVersion');
    clearStorage('sasp-ratingEpoch');
    
    if (code.errorID === "") {
        if (code.totalDevices > 2) {
            dispatch({
                type: DEREGISTER
            });

            dispatch({
                type: SEND_SUCCESS_LOGIN_FEEDBACK,
                payload: code
            });
            
            return <Redirect push to={{ pathname: "/deregister" }} />;
        } else {
            dispatch({
                type: SEND_SUCCESS_LOGIN_FEEDBACK,
                payload: code
            })
            dispatch({
                type: LOGIN_USER_SUCCESS
            });

            localStorage.removeItem('sasp-hideDaily');
        }
    } else if (code.errorID === "0") {
        dispatch({
            type: SEND_SUCCESS_LOGIN_FEEDBACK,
            payload: code
        })
        dispatch({
            type: LOGIN_USER_SUCCESS
        });
    } else if (code.errorID === "3") {
        error = {
            errorMessage:
                "Uh Oh. We don't have a record of your purchase for this product. <br><br>Please contact customer service",
            errorCode: "3"
        };
        dispatch({
            type: LOGIN_USER_FAIL,
            payload: error
        });
    } else if (code.errorID === "4" || code.errorID === "2" || code.errorID === "1") {
        error = {
            errorMessage:
                "There was a problem with your username or password. <br><br>Please try again.",
            errorCode: code.errorID
        };
        dispatch({
            type: LOGIN_USER_FAIL,
            payload: error
        });
    } else {
        error = {
            errorMessage:
                "There was a problem with your username or password. <br><br>Please try again.",
            errorCode: "No error code"
        };
        dispatch({
            type: LOGIN_USER_FAIL,
            payload: error
        });
    }
};

const login_fail = error => {
    return {
        type: LOGIN_USER_FAIL,
        payload: error
    };
};

export const deRegister = (mcid, key) => async dispatch => {
    clearStorage('sasp-dailyEpoch');
    clearStorage('sasp-hideVersion');
    clearStorage('sasp-ratingEpoch');
    clearStorage('login_dt');
    clearStorage('sasp_user_details');
    clearStorage('auth_feedback');

    try {
        const response = await apiDeRegister(mcid, key);
        dispatch({
            type: LOGIN_USER_SUCCESS
        });
        return <Redirect push to={{ pathname: "/splash" }} />
        // return <Redirect to="/splash"/>;
    } catch (error) {
        dispatch({
            type: DEREGISTER_FAILED,
            payload: error
        });
    }
};

export const getUserDetails = (mcid, key, tracking) => async dispatch => {
    try {
        const response = await apiGetUserDetails(mcid, key, tracking);

        if (typeof response.statuscode !== 'undefined') {
            if (response.statuscode.toString() === '403') {
                dispatch(logout())
            } else {
                dispatch({
                    type: GET_USER_DETAILS,
                    payload: response[0]
                });
            }
        } else {
            dispatch({
                type: GET_USER_DETAILS,
                payload: response[0]
            });
        }        
    } catch (error) {
        /*dispatch({
            type: GET_USER_DETAILS_FAILED,
            payload: error
        });*/

        dispatch(logout());
    }
};

export const getSASPYears = (data) => async dispatch => {
    try {
        const response = await apiGetSASPYears(data);

        if (typeof response === 'string') {
            dispatch({
                type: SASP_CME_YEARS,
                payload: null
            });

            return null;
        }

        dispatch({
            type: SASP_CME_YEARS,
            payload: response
        });
    } catch (error) {
    }
}

export const getRanking = (data) => async dispatch => {
    try {
        const response = await apiGetAppReporting(data);

        if (typeof response === 'string') {
            return null;
        }

        dispatch({
            type: SASP_REPORT,
            payload: response
        });
    } catch (error) {
    }
}

export const getMessages = (data) => async dispatch => {
    try {
        const response = await apiGetMessages(data);

        if (typeof response === 'string') {
            return null;
        }

        dispatch({
            type: GET_MESSAGES,
            payload: response
        });
    } catch (error) {
    }
}

export const confirmCME = (data, tracking) => async dispatch => {
    try {
        const response = await apiConfirmCME(data, tracking);

        dispatch({
            type: CME_CONFIRMATION
        })
    } catch(error) {
        dispatch({
            type: CME_CONFIRMATION_FAILED,
            payload: error
        })
    }
};

export const logout = () => async dispatch => {
    if (localStorage.length > 0 ) {
        // localStorage.clear();
        clearStorage('org.auanet.auau.sasp');
    }

    try {
        dispatch({
            type: LOGOUT_SUCCESS
        });
        return <Redirect to="/login"/>;
    } catch (e) {
        dispatch({
            type: LOGOUT_FAILURE,
            payload: e
        })
    }
}

export const sendSASPResidentAccess = (data) => async dispatch => {
    try {
        const response = await apiSendSASPResidentAccess(data); 

        dispatch({
            type: GET_RESIDENCY_PROGRAM,
            payload: response
        })
    } catch (e) {
        dispatch({
            type: GET_RESIDENCY_PROGRAM_FAILED,
            payload: e
        })
    }
}

export const getSASPResidencyProgram = (data) => async dispatch => {
    try {
        const response = await apiGetSASPResidencyProgram(data); 
        dispatch({
            type: GET_RESIDENCY_PROGRAM,
            payload: response
        })
    } catch (e) {
        dispatch({
            type: GET_RESIDENCY_PROGRAM_FAILED,
            payload: e
        })
    }
}

export const getSASPResidentData = (data) => async dispatch => {
    try {
        const response = await apiGetSASPResidenctData(data); 
        
        dispatch({
            type: GET_RESIDENT_DATA,
            payload: response
        })
    } catch (e) {
        dispatch({
            type: GET_RESIDENT_DATA_FAILED,
            payload: e
        })
    }
}

export const updateUserProfile = (data) => async dispatch => {
    try {
        const response = await apiUpdateUser(data);
        dispatch({
            type: UPDATE_PROFILE,
            payload: response[0]
        })

        return <Redirect to="/home"/>;
    } catch (e) {
        dispatch({
            type: UPDATE_PROFILE_FAIL,
            payload: e
        })
    }
}

export const getLeaderboard = (data) => async dispatch => {
    try {
        const response = await apiGetLeaderboard(data);
        dispatch({
            type: SASP_LEADREBOARD,
            payload: response
        })
    } catch (e) {
        dispatch({
            type: SASP_LEADREBOARD_FAILED,
            payload: e
        })
    }
}

export const getAccessList = (data) => async dispatch => {
    const response = await apiGetAccessList(data);
    try {
        dispatch({
            type: SHARE_USERS,
            payload: response
        })
    } catch (e) {
        dispatch({
            type: SHARE_USERS_FAILED,
            payload: e
        })
    }
}

export const updateNotification = (data) => async dispatch => {
    const response = await apiUpdateNotification(data);
    try {
        dispatch({
            type: NOTIFICATIONS,
            payload: response
        })
    } catch (e) {
        dispatch({
            type: NOTIFICATIONS_FAILED,
            payload: e
        })
    }
}

export const updateRating = (data) => async dispatch => {
    const response = await apiRateApp(data);
    try {
        dispatch({
            type: RATE_APP,
            payload: response
        })
    } catch (e) {
        dispatch({
            type: RATE_APP_FAILED,
            payload: e
        })
    }
}